import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import UserService from '../services/user-service';

export default function usePreferences() {
	const { isInitialLoading: isLoading, isError: isErrorLoading, data } = useQuery(['getPreferences'], () => UserService.getPreferences());
	const session = data?.session;
	const sessionId = session?.id;
	const preferences = session?.preferences;

	const queryClient = useQueryClient();

	const { mutateAsync: updatePreferences, isLoading: isSaving } = useMutation(
		(prefs) => UserService.updatePreferences(sessionId, prefs),
		{
			onSuccess: (data) => queryClient.setQueryData(['getPreferences'], data.updateSession)
		}
	);

	return {
		session,
		isLoading,
		isErrorLoading,
		preferences,
		isSaving,
		updatePreferences
	};
}
